import React, {Fragment} from "react";
import {BrowseButton} from "../buttons";

const RecommendationItem = ({ title, cost, url, cover }) => {
  const costAsCurrency = cost.toFixed(2);
  return (
    <div className="column is-4">
      <div className="is-hidden-mobile">
        <div className="book-cover">
          <figure className="image"><a href={url} target="_blank"><img src={cover} alt=""/></a></figure>
        </div>
        <div className="book-title">{title}</div>
        <div className="book-cost">${costAsCurrency}</div>
        <BrowseButton url={url} />
      </div>
      <div className="is-hidden-tablet v-centered-left-align">
        <a href={url} target="_blank">
          <div className="book-cover">
            <figure className="image"><img src={cover} alt=""/></figure>
          </div>
        </a>
        <div>
          <div className="book-title">{title}</div>
          <div className="book-cost">${costAsCurrency}</div>
          <BrowseButton url={url} />
        </div>
      </div>
    </div>
  );
};

export default ({ recommendations }) => {
  const [rec1, rec2, rec3] = recommendations;
  const withRecommendations = (
    <Fragment>
      <div className="columns has-text-centered">
        <div className="column is-12">
          <div className="recommendations-title">
            <h4>Recommended titles from the Top Hat <strong>Marketplace</strong></h4>
            <p>
              <strong>Your Source for Affordable, Engaging and High-Quality Course Content</strong>
            </p>
            <p>
              Browse over 20,000 interactive textbooks, question packs, presentations
              and other course materials that you can mix and match to suit the needs of your course.
            </p>
          </div>
        </div>
      </div>
      <div className="columns is-centered">
        <RecommendationItem {...rec1} />
        <RecommendationItem {...rec2} />
        <RecommendationItem {...rec3} />
      </div>
    </Fragment>
  );
  return recommendations.length > 0 ? withRecommendations : null;
};


// WEBPACK FOOTER //
// ./src/components/recommendations/index.js